import { Box, Button, CircularProgress, Grid, Switch } from '@mui/material';
import Error from 'components/Error';
import Logo from 'components/Logo';
import { useAuthToken } from 'hooks/useAuthToken';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { getUser, updateContact } from 'services/contact';

const Contact = ({ isMobile, setCurrentBrand, currentBrand }) => {

  const [searchParams] = useSearchParams();
  const { control, handleSubmit } = useForm();

  //hook auth
  const { isLoadingToken, appToken, getAuthToken } = useAuthToken();

  //data
  const [member, setMember] = useState();
  const [isActive, setIsActive] = useState(false);
  const [loadingSave, setloadingSave] = useState(false);
  const [memberUuid, setMemberUuid] = useState();
  const [acceptContact, setAcceptContact] = useState(true);
  const [loading, setLoading] = useState(true);

  //results
  const [messageError, setMessageError] = useState();
  const [succesMessage, setSuccesMessage] = useState();

  useLayoutEffect(() => {
    setCurrentBrand(searchParams.get("b"));
    setMemberUuid(searchParams.get("m"));
    setIsActive(searchParams.get("a") == 1);
    localStorage.setItem("current_brand", searchParams.get("b"));

    getAuthToken();
  }, [])

  useEffect(() => {
    if (appToken && memberUuid && !isLoadingToken) {
      setLoading(true);
      getUser(memberUuid)
        .then(({ data }) => {
          if (data?.data?.id) {
            setMember(data?.data);
          } else {
            setMessageError("No encontramos informacion");
          }
        })
        .catch((err) => {
          setMessageError(Array.isArray(err?.message) ? err?.message[0] : (err?.message ?? "Error, intente de nuevo."));
        })
        .finally(() => setLoading(false))
    }
  }, [appToken, memberUuid, isLoadingToken])

  const onSubmit = (values) => {
    setloadingSave(true);
    updateContact(member?.id, values)
      .then(({ data }) => {
        if (data.status == 'success') {
          setSuccesMessage('Actualizado');
        } else {
          throw data;
        }
      })
      .catch((err) => {
        setMessageError(Array.isArray(err?.message) ? err?.message[0] : (err?.message ?? "Error, intente de nuevo."));
      })
      .finally(() => setloadingSave(false))
  }

  return (
    <Grid container style={{ padding: 10 }} >
      <Grid item xs={12} >
        <Logo />
      </Grid>

      {
        messageError &&
        <Grid item xs={12} >
          <Error customTitle={messageError} linkButton={""} />
        </Grid>
      }

      {
        succesMessage &&
        <Grid item xs={12} >
          <Error customTitle={succesMessage} linkButton={""} customMessage={"Gracias."} />
        </Grid>
      }

      {
        !messageError && !succesMessage &&
        <Grid item xs={12}>
          {
            (isLoadingToken || loading) ?
              <Box margin={'0 auto'} marginTop={"30vh"} width={'40px'} ><CircularProgress /></Box>
              :
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container style={{ width: isMobile ? '90%' : '60%', margin: '0 auto' }} spacing={2} >
                  <Grid item xs={12}>
                    <b>{member.first_name}</b>
                  </Grid>
                  <Grid item xs={12}>
                    Seleccionalos a continuación: <br />
                  </Grid>
                  <Grid item xs={12}>
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <Controller
                        control={control}
                        name={'contact'}
                        defaultValue={member?.contact == 1 ?? false}
                        render={({ field }) => (
                          <Switch
                            {...field}
                            defaultChecked={member?.contact == 1 ?? false}
                            onChange={(e) => {
                              field.onChange(e.target.checked)
                            }}
                          />
                        )}
                      />
                      Autorizo recibir información relacionada con {isActive ? "el bien y/o servicio adquirido" : "salud, bienestar y estilo de vida saludable"} <br />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    Autorizo recibir información comercial a través de:  <br />
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} >
                    <Controller
                      control={control}
                      name={'contact_email'}
                      defaultValue={member?.contact_email == 1 ?? false}
                      render={({ field }) => (
                        <Switch
                          {...field}
                          defaultChecked={member?.contact_email == 1 ?? false}
                          onChange={(e) => {
                            field.onChange(e.target.checked)
                          }}
                        />
                      )}
                    />
                    Email
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} >
                    <Controller
                      control={control}
                      name={'contact_sms'}
                      defaultValue={member?.contact_sms == 1 ?? false}
                      render={({ field }) => (
                        <Switch
                          {...field}
                          defaultChecked={member?.contact_sms == 1 ?? false}
                          onChange={(e) => {
                            field.onChange(e.target.checked)
                          }}
                        />
                      )}
                    />
                    SMS
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} >
                    <Controller
                      control={control}
                      name={'contact_whatsapp'}
                      defaultValue={member?.contact_whatsapp == 1 ?? false}
                      render={({ field }) => (
                        <Switch
                          {...field}
                          defaultChecked={member?.contact_whatsapp == 1 ?? false}
                          onChange={(e) => {
                            field.onChange(e.target.checked)
                          }}
                        />
                      )}
                    />
                    Whatsapp
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} >
                    <Controller
                      control={control}
                      name={'contact_phone'}
                      defaultValue={member?.contact_phone == 1 ?? false}
                      render={({ field }) => (
                        <Switch
                          {...field}
                          defaultChecked={member?.contact_phone == 1 ?? false}
                          onChange={(e) => {
                            field.onChange(e.target.checked)
                          }}
                        />
                      )}
                    />
                    Llamadas telefónicas
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} >
                    <Controller
                      control={control}
                      name={'contact_app'}
                      defaultValue={member?.contact_app == 1 ?? false}
                      render={({ field }) => (
                        <Switch
                          {...field}
                          defaultChecked={member?.contact_app == 1 ?? false}
                          onChange={(e) => {
                            field.onChange(e.target.checked)
                          }}
                        />
                      )}
                    />
                    Notificaciones APP {['1', '3'].includes(currentBrand) ? 'BODYTECH' : 'Athletic'}
                  </Grid>
                  <Grid item xs={12} >
                    Gracias por permitirnos transformar tu vida con la mejor información de salud, bienestar y estilo de vida saludable para tu vida.
                  </Grid>
                  <Grid item xs={12}>
                    <Box width={"40%"} margin={'0 auto'} >
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                      >
                        {
                          loadingSave ?
                            <CircularProgress color='inherit' />
                            : "Actualizar"
                        }
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
          }
        </Grid>
      }

    </Grid>
  )
}

export default Contact;
